import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "antd";
import { Formik } from "formik";
import { Form } from "formik-antd";
import * as yup from "yup";
import { FORM_ITEM_LAYOUT_PROPS_BY_FORM_LAYOUT } from "../../../constants/formConstants";
import FormFieldDivider from "../../FormFields/FormFieldDivider";
import FormFieldRegistration from "../../FormFields/FormFieldRegistration";


const FIELDS = {
  RegId: {
    type: "registration",
    label: "Registration",
    placeholder: "Select a registration",
    helpText:
      "Returns competitors grouped by the Registration they were configured under.",
    allowClear: true,
    disableArchivedRecords: false,
  },
};

const INITIAL_VALUES = {
  RegId: undefined,
};



const VALIDATION_SCHEMA = yup.object().shape({
  RegId: yup.string().required("Please select a Registration to query."),
});

function TeamlessCompetitorsReportForm({ handleSubmit }) {
  return (
    <Formik
      initialValues={INITIAL_VALUES}
      validationSchema={VALIDATION_SCHEMA}
      onSubmit={(values, actions) => handleSubmit(VALIDATION_SCHEMA.cast(values), actions)}
      isInitialValid={VALIDATION_SCHEMA.isValidSync(INITIAL_VALUES)}
      enableReinitialize
    >
      {({ isSubmitting, submitCount, submitForm }) => {
        return (
          <Form {...FORM_ITEM_LAYOUT_PROPS_BY_FORM_LAYOUT.vertical}>
            <Typography.Title level={4}>Report options</Typography.Title>

            <FormFieldRegistration name="RegId" meta={FIELDS.RegId} submitCount={submitCount} />

            <FormFieldDivider />

            <Button type="primary" size="large" loading={isSubmitting} onClick={submitForm} block>
              Generate Report
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
}

TeamlessCompetitorsReportForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

export default TeamlessCompetitorsReportForm;
